<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.85677 2L2.22786 3.10807L5.49219 4.60547C5.58952 4.4445 5.71305 4.27978 5.82161 4.1263L2.85677 2ZM22.1432 2L19.1784 4.1263C19.2869 4.27978 19.4105 4.4445 19.5078 4.60547L22.7721 3.07812L22.1432 2ZM12.5 2.0599C8.79395 2.0599 5.79167 5.06217 5.79167 8.76823C5.79167 12.9647 9.625 14.4321 9.625 18.3516L15.375 17.3333C15.375 14.1701 19.2083 12.9647 19.2083 8.76823C19.2083 5.06217 16.2061 2.0599 12.5 2.0599ZM1 7.66016V8.91797L4.35417 8.61849C4.35791 8.4126 4.3654 8.22168 4.38411 8.01953L1 7.66016ZM24 7.66016L20.6159 8.01953C20.6346 8.22168 20.6421 8.4126 20.6458 8.61849L24 8.91797V7.66016ZM5.13281 12.1823L2.22786 13.4701L2.85677 14.5781L5.43229 12.7812C5.32747 12.5941 5.2264 12.3844 5.13281 12.1823ZM19.8372 12.1823C19.7362 12.3807 19.6463 12.5679 19.5378 12.7513L22.1432 14.6081L22.7721 13.4701L19.8372 12.1823ZM14.806 17.8724L10.0143 18.8307C9.74853 18.8794 9.57633 19.134 9.625 19.3997C9.67366 19.6655 9.92822 19.8377 10.194 19.7891L14.9857 18.8307C15.2515 18.7821 15.4237 18.5275 15.375 18.2617C15.3263 17.9959 15.0718 17.8237 14.806 17.8724ZM14.806 19.3099L10.0143 20.2682C9.74853 20.3169 9.57633 20.5715 9.625 20.8372C9.67366 21.103 9.92822 21.2752 10.194 21.2266L14.9857 20.2682C15.2515 20.2196 15.4237 19.965 15.375 19.6992C15.3263 19.4334 15.0718 19.2612 14.806 19.3099ZM13.9375 21.2266L11.0625 21.7057C11.0625 22.4993 11.7064 23.1432 12.5 23.1432C13.2936 23.1432 13.9375 22.6042 13.9375 21.2266Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgIdea',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>